import { render, staticRenderFns } from "./AllTodos.vue?vue&type=template&id=7d919a80"
import script from "./AllTodos.vue?vue&type=script&lang=ts"
export * from "./AllTodos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports